import React from "react";

const Logout = (props) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.08499 19.5H3.20045C1.71105 19.5 0.503418 18.2857 0.503418 16.7963V3.19703C0.503418 1.70763 1.71105 0.5 3.20045 0.5H7.08499C7.50095 0.5 7.8364 0.835452 7.8364 1.25141C7.8364 1.66737 7.50095 2.00282 7.08499 2.00282H3.20045C2.54297 2.00282 2.01295 2.53284 2.01295 3.19033V16.7895C2.01295 17.447 2.54297 17.977 3.20045 17.977H7.08499C7.50095 17.977 7.8364 18.3125 7.8364 18.7285C7.8364 19.1444 7.50095 19.4799 7.08499 19.4799V19.5Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M13.8875 15.6086C13.693 15.6086 13.4984 15.5348 13.3508 15.3872C13.0556 15.092 13.0556 14.6157 13.3508 14.3205L17.6781 9.99987L13.3508 5.67925C13.0556 5.38405 13.0556 4.90771 13.3508 4.61251C13.646 4.31731 14.1223 4.31731 14.4175 4.61251L19.2749 9.46986C19.5701 9.76505 19.5701 10.2414 19.2749 10.5366L14.4175 15.3939C14.2699 15.5415 14.0754 15.6153 13.8808 15.6153L13.8875 15.6086Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M18.7452 10.7514H7.08491C6.66895 10.7514 6.3335 10.4159 6.3335 9.99995C6.3335 9.58399 6.66895 9.24854 7.08491 9.24854H18.7452C19.1612 9.24854 19.4966 9.58399 19.4966 9.99995C19.4966 10.4159 19.1612 10.7514 18.7452 10.7514Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default Logout;
